import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { Card, Collapsable } from '@beat-venues/ui/subset';
import { TextLink } from '../../atoms';
import { useTranslation } from 'next-i18next';
import { SetlistData } from '@beat-venues/common-types';

import type { JSX } from 'react';

export interface SetlistProps
    extends CommonProps,
        VariantProps<typeof SetlistStyles> {
    setlist: SetlistData;
}

export const SetlistStyles = tv({
    slots: {
        root: 'mt-10 lg:w-1/2',
        heading: 'mb-0 flex flex-col',
        setslist: 'setlist flex flex-col gap-2',
        setItem: 'flex flex-col gap-2',
        songlist: 'flex flex-col gap-2 pl-3',
        songitem: 'flex',
        listItemMarker: 'song-marker inline-block w-8',
        songCover: 'block text-xs',
    },
    variants: {},
});

export const Setlist = ({
    className,
    setlist,
    testId = 'setlist',
}: SetlistProps): JSX.Element => {
    const {
        root,
        heading,
        setslist,
        setItem,
        songlist,
        songitem,
        listItemMarker,
        songCover,
    } = SetlistStyles();
    const { t } = useTranslation(['event']);

    return (
        <Card className={root({ className })} data-testid={testId}>
            <Card.Header className={heading()} title={t('setlist.title')}>
                <div>
                    {t('setlist.viewAt')}{' '}
                    <TextLink href={setlist.url}>setlist.fm</TextLink>
                </div>
            </Card.Header>
            <Collapsable collapsableElementId="setlist" height={250}>
                <ul className={setslist()} id="setlist">
                    {setlist.sets.set.map((set, index) => (
                        <li className={setItem()} key={`set-${index}`}>
                            {`${set.name ?? ''}${
                                (set.encore && set.name) ?? ' '
                            }${set.encore ? `Encore ${set.encore}` : ''}`}
                            <ol className={songlist()}>
                                {set.song.map((songItem, songIndex) => (
                                    <li
                                        className={songitem()}
                                        key={`${songItem.name}-${songIndex}`}
                                    >
                                        <span
                                            className={listItemMarker()}
                                        ></span>
                                        <div>
                                            {songItem.name}
                                            <span className={songCover()}>
                                                {songItem.cover
                                                    ? `(${songItem.cover.name} cover)`
                                                    : ''}
                                            </span>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </li>
                    ))}
                </ul>
            </Collapsable>
        </Card>
    );
};
